import * as React from 'react';
import {IonToolbar, IonChip, IonIcon} from "@ionic/react";
import {chevronBack, chevronForward} from "ionicons/icons";
import {AvailableDateOption} from "./slots-page.component";
import {dateToFormat} from "../../../utils/ages";
import SkeletonText from "../../../components/common/SkeleltonText";

interface DatesToolbarProps {
    availableDates: AvailableDateOption[];
    selectedWeekIndex: number;
    weeksAvailablePast: number;
    weeksAvailableFuture: number;
    isRefreshing: boolean;
    isChangingBooking: boolean;
    isChangingWeek: boolean;
    onPreviousWeekClicked: () => void;
    onNextWeekClicked: () => void;
    selectedDate: number;
    setSelectedDate: (date: number) => void;
}

export const DatesToolbar: React.FC<DatesToolbarProps> = React.memo(({
    availableDates,
    selectedWeekIndex,
    weeksAvailablePast,
    weeksAvailableFuture,
    isRefreshing,
    isChangingBooking,
    isChangingWeek,
    onPreviousWeekClicked,
    onNextWeekClicked,
    selectedDate,
    setSelectedDate
}) => {
    return (
        <div className={"dates-toolbar-holder"}>
            <IonToolbar className="dates-toolbar">
                {availableDates && selectedWeekIndex > -weeksAvailablePast && (
                    <IonChip disabled={isChangingWeek || isChangingBooking} onClick={onPreviousWeekClicked}
                             className={'ion-text-center ion-no-padding text-bold date-filter-week-changer date-filter-option-show-history'}
                             key="date-filter-option-previous-week"
                    >
                        <IonIcon icon={chevronBack}/>
                    </IonChip>
                )}
                {
                    availableDates && availableDates.map((dateFilterOption, i) =>
                        (<IonChip
                            className={`ion-text-center ion-no-padding ion-no-margin date-filter-option
                                 ${dateFilterOption.isPast && ' date-filter-option-is-past'}
                                 ${dateFilterOption.isBooked && ' date-filter-option-is-booked'}
                                 ${dateFilterOption.isWaitingBooked && ' date-filter-option-is-waiting-booked'}
                                 ${dateFilterOption.isFrozen && ' date-filter-option-is-frozen'}
                                 ${dateFilterOption.isHoliday && ' date-filter-option-is-holiday'}`}
                            outline={selectedDate !== dateFilterOption.ts}
                            disabled={!dateFilterOption.active || isChangingBooking || isChangingWeek}
                            color={selectedDate === dateFilterOption.ts ? "primary" : undefined}
                            key={`date-filter-option-${dateFilterOption.ts}`}
                            onClick={() => {
                                setSelectedDate(dateFilterOption.ts)
                            }}
                        >
                            <div
                                className={`date-filter-option-inner ${selectedDate === dateFilterOption.ts && " text-bold"}`}
                            >
                                {dateToFormat(dateFilterOption.date, window.innerWidth <= 450 ? 'DD' : 'ddd')}
                                <br/>
                                {
                                    (isRefreshing &&
                                    <SkeletonText style={{'height': '8px'}}></SkeletonText>)
                                    || dateFilterOption.date.getDate()
                                }
                                {!isRefreshing && (dateFilterOption.isBooked || dateFilterOption.isWaitingBooked) && <div className={"date-filter-option-booked-marker"}></div>}
                            </div>
                        </IonChip>)
                    )
                }
                {availableDates && selectedWeekIndex < weeksAvailableFuture && (
                    <IonChip disabled={isChangingWeek || isChangingBooking} onClick={onNextWeekClicked}
                             className={'ion-text-center ion-no-padding text-bold date-filter-week-changer date-filter-option-show-history'}
                             key="date-filter-option-next-week"
                    >
                        <div className="ion-text-center ion-no-padding date-filter-week-changer-inner ">
                            <IonIcon icon={chevronForward}/>
                        </div>
                    </IonChip>
                )}
            </IonToolbar>
        </div>
    );
});
